export enum PopulationEnrollmentTagEnum {
    FullProgramReferralDescription = 'Full Program Referral',
    FullProgramReferral = 1,
    HRAReferralDescription = 'HRA Referral',
    HRAReferral = 2
}
